import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import MapIcon from '@mui/icons-material/Map';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';

import {
  ConfirmActionBtn, RootContainer, Title, ViewContainer,
  ViewMapButton, ViewMapButtonGroup, ViewText
} from './styles';

import { MessageTypeConstants } from '../../../../services/bot/Message';
import { processSendMessage } from '../../../../services/bot/conversation/SendMessage';
import { handleCalendarChange } from '../../../../state/actionsHelpers/tabStackActionsHelpers/message-type-container';
import RenderContentView from './RenderContentView';
import { setBotWaitLoaderWithShimmer } from '../../../../state/actions/loader';
import { setTabState } from '../../../../state/actions/tabStack';


const FMCalendarComponent = ({
  options,
  message,
  rows,
  conversation,
  messageType,
  parentTabId,
  parentDocId,
  inContainer,
}) => {

  const dispatch = useDispatch();
  const mainView = messageType;
  const [style, setStyle] = useState(options.style || mainView);
  const [viewType, setViewType] = useState([mainView, 'table']);


  useEffect(() => {
    if (options?.mapOptions) {
      if (options?.mapOptions?.table) {
        setViewType([mainView, 'table'])
      }
      else {
        setViewType([mainView])
      }
    }
    else {
      setViewType([mainView, 'table'])
    }
  }, [options]);


  const handleChange = (event) => {
    setStyle(event);
    dispatch(handleCalendarChange(conversation, options, 'style', event, parentTabId));
  };


  const handleAction = (action = 'onAction', content = null) => {
    const responseChat = {};
    responseChat.messageType = MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE;
    responseChat.message = {
      controlId: options.controlId,
      tabId: options?.parent?.length ? parentTabId : options.tabId,
      parentDocId,
      action,
      content,
    };
    dispatch(setTabState(false))
    dispatch(setBotWaitLoaderWithShimmer(true));
    processSendMessage(responseChat);
  };


  const renderButtons = (view, style) => {
    switch (view) {
      case 'calendar':
        return (
          <DateRangeOutlinedIcon
            style={style === view ? { fill: '#2DC0EF' } : { fill: '#dedede' }} />
        );
      case 'map':
        return (
          <MapIcon
            style={style === view ? { fill: '#2DC0EF' } : { fill: '#dedede' }} />
        );
      default:
        return (
          <TableChartOutlinedIcon
            style={style === view ? { fill: '#2DC0EF' } : { fill: '#dedede' }} />
        );
    }
  };

  return (
    <>
      <RootContainer
        container // direction="row"
        justifyContent='space-between'
        alignItems='center'>

        {/* <div className="text-size-18 font-semibold text-black ml-3 my-3">
          {options?.title || ""}
        </div> */}

        <ViewContainer>
          {
            viewType && viewType.length > 1 &&
            <>
              <ViewText
                variant='body2'
                style={{
                  visibility:
                    options?.mapOptions?.listType === 'areas'
                      ? 'hidden'
                      : 'visible',
                  fontSize: '0.85em',
                }}>
                View:
              </ViewText>
              <FormControl
                className='icon-img'
                component='fieldset'
                style={{
                  visibility:
                    options?.mapOptions?.listType === 'areas'
                      ? 'hidden'
                      : 'visible',
                }}
              >
                <ViewMapButtonGroup
                  size='small'
                  aria-label='small outlined button group'
                  spacing={2}
                >
                  {viewType.map((view) => (
                    <Tooltip title={`${view} view`}>
                      <ViewMapButton
                        onClick={() => handleChange(view)}
                        style={
                          style === view
                            ? { backgroundColor: 'rgba(0, 167, 214, 0.1)' }
                            : {}
                        }
                      >
                        {renderButtons(view, style)}
                      </ViewMapButton>
                    </Tooltip>
                  ))}
                </ViewMapButtonGroup>
              </FormControl>
            </>
          }

          {options?.confirmAction && (
            <ConfirmActionBtn
              variant='contained'
              color='primary'
              onClick={() => handleAction('onConfirm')}
            >
              {options?.confirmAction}
            </ConfirmActionBtn>
          )}

        </ViewContainer>
      </RootContainer>

      <RenderContentView
        style={style}
        rows={rows}
        conversation={conversation}
        messageType={messageType}
        options={options}
        message={message}
        parentTabId={parentTabId}
        parentDocId={parentDocId}
        inContainer={inContainer}
        handleAction={handleAction}
      />
    </>
  );
};

export default FMCalendarComponent;
